import { render, staticRenderFns } from "./roleManage.vue?vue&type=template&id=518e961e&scoped=true&"
import script from "./roleManage.vue?vue&type=script&lang=js&"
export * from "./roleManage.vue?vue&type=script&lang=js&"
import style0 from "./roleManage.vue?vue&type=style&index=0&id=518e961e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518e961e",
  null
  
)

export default component.exports